export default __webpack_public_path__ + "static/media/star_big_empty.183a4725.svg";